<template>
    <div v-cloak>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3>
                    Importar Planilha

                    <i class="fa fa-database right" style="font-size:21px;"></i>
                </h3>
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-md-5 m-r-md">
                        <form action="">
                            <div class="row">
                                <div class="col-md-12 m-l-sm">
                                    <div class="form-group">
                                        <label for="type" class="mt-0">Tipo de Importação</label>
                                        <select class="form-control" v-model="imports.type" id="type">
                                            <option value="">Selecione uma opção</option>
                                            <!--<option value="insert">Adicionar Registros</option>-->
                                            <!--<option value="edit">Alterar Registros</option>-->
                                            <option value="delete">Remover Registros</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 m-l-sm">
                                    <div class="form-group">
                                        <label for="record" class="mt-0">Registro</label>
                                        <select class="form-control" v-model="imports.record" id="record">
                                            <option value="">Selecione uma opção</option>
                                            <option value="category_products">Categorias de Produto</option>
                                            <option value="category_recipes">Categorias de Receita</option>
                                            <option value="sub_category_products">Sub-Categorias de Produto</option>
                                            <option value="recipes">Receitas</option>
                                            <option value="products">Produtos</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-9 m-l-sm">
                                    <label for="file">Arquivo Excel (.xlsx)</label>
                                    <input type="file" style="margin-top:5px;" id="file">
                                </div>
                                <div class="col-md-2 text-right">
                                    <button type="button" class="btn btn-success m-t-sm" @click="importation">
                                        Importar <i class="fa fa-upload"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-4 m-t-sm">
                        <div class="ibox animated fadeInLeftBig">
                            <div class="ibox-title" style="padding:16px;border-bottom:1px solid #f0f0f0;">
                                <h4 style="margin:0">
                                    Modelo de Planilha
                                    <i class="fa fa-bookmark right"></i>
                                </h4>
                            </div>
                            <div class="ibox-content">
                                <form action="">
                                    <div class="form-group">
                                        <label for="records">Registro</label>
                                        <select class="form-control" id="records" v-model="exports.record">
                                            <option value="">Selecione uma opção</option>
                                            <option value="category_products">Categorias de Produto</option>
                                            <option value="category_recipes">Categorias de Receita</option>
                                            <option value="sub_category_products">Sub-Categorias de Produto</option>
                                            <option value="recipes">Receitas</option>
                                            <option value="products">Produtos</option>
                                        </select>
                                    </div>

                                    <div class="form-group m-t-md text-right" style="margin-bottom:0;">
                                        <button type="button" class="btn btn-success" @click="exportation">
                                            Exportar Modelo <i class="fa fa-download"></i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                imports: {
                    type: '',
                    record: ''
                },
                exports: {
                    record: ''
                }
            };
        },
        methods: {
            importation: function () {
                const self = this;
                const api = self.$store.state.url + 'datasheet/import';

                let form = new FormData();
                let file = document.getElementById('file');

                if(!file.files[0]){
                    self.$error('Preencha o arquivo para prosseguir');
                    return false;
                }

                form.append('type', self.imports.type);
                form.append('record', self.imports.record);
                form.append('file', (file.files[0]) ? file.files[0] : '');

                self.$http
                    .post(api, form)
                    .then((response) => {
                        self.$message(null, 'Importação realizada com sucesso.', 'success');
                    })
                    .catch((error) => {
                        self.$error(error);
                    });
            },
            exportation: function () {
                const self = this;
                window.location.href = self.$store.state.url + 'datasheet/export?record=' + self.exports.record;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Import/Index.vue